import { render, staticRenderFns } from "./TagSelector.vue?vue&type=template&id=014495e4&scoped=true&"
import script from "./TagSelector.vue?vue&type=script&lang=js&"
export * from "./TagSelector.vue?vue&type=script&lang=js&"
import style0 from "./TagSelector.vue?vue&type=style&index=0&id=014495e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014495e4",
  null
  
)

export default component.exports